export const priceBYN = price => price ? (+price).toFixed(2) : "0.00";
export const PRICE_PENNY = '0.01';
